module.exports = __webpack_public_path__ + "static/Stationary-35e85154e7375db5512cfa644c79d410.svg";